<div
    class="agpr-multiSelectDropdown"
    [id]="id"
>
    <!-- Label -->
    <div>
        <label *ngIf="label" [id]="id + '_multiSelectDropdown_label'" class="agpr-multiSelectDropdown-label">
            {{label | localize }}
        </label>
        <span *ngIf="required" class="agpr-requiredAsterix"> * </span>
        <!-- Info Icon -->
        <span
            *ngIf="tooltip"
            role="img"
            class="agpr-multiSelectDropdown-tooltip fa-regular fa-circle-info"
            [agprTooltip]="tooltip"
        ></span>
    </div>
    <!-- Hint -->
    <div *ngIf="hint" [id]="id + '-hint'" class="agpr-multiSelectDropdown-hint">{{hint | localize}}</div>
    <!-- Container -->
    <div
        #container
        class="agpr-multiSelectDropdown-container"
        [ngClass]="{'hasChips': selectedOptions?.length > 0 && displayChips}"
    >
        <input
            *ngIf="!isAutocomplete"
            #focusInput
            readonly
            [id]="id + '-input'"
            class="agpr-multiSelectDropdown-input"
            [ngClass]="{'agpr-multiSelectDropdown-input--hasChips': value?.length > 0}"
            [disabled]="disabled"
            (click)="onMouseclick($event)"
            (keydown)="onKeydown($event)"
            type="text"
            [placeholder]="placeholder | localize"
            [attr.aria-labelledby]="ariaLabelledBy ? ariaLabelledBy : (label ? id + '_multiSelectDropdown_label' : null)"
            [attr.aria-label]="ariaLabel | localize"
            [attr.aria-describedby]="selectedOptions?.length > 0 ? id + '_chips' : ''"
        />
        <agpr-autocomplete
            *ngIf="isAutocomplete"
            [id]="id + '-autocomplete-input'"
            [disabled]="disabled"
            [placeholder]="placeholder | localize"
            [suggestions]="options$"
            labelField="label"
            [itemTemplate]="template"
            [panelStyleClass]="panelStyleClass + 'agpr-multiSelectDropdown-autocomplete-panel'"
            (keydown)="onKeydown($event)"
            (click)="onMouseclick($event)"
            [(ngModel)]="autocompleteSelection"
            (itemSelected)="toggleAutocompleteItem($event)"
            (show)="hide()"
            [ariaLabel]="ariaLabel"
            [customOptions]="customAutocompleteOptions"
            [ariaLabelledBy]="ariaLabelledBy ? ariaLabelledBy : (label ? id + '_multiSelectDropdown_label' : null)"
            [ariaDescribedBy]="selectedOptions?.length > 0 ? id + '_chips' : ''"
        >
            <!-- Autocomplete Option Template -->
            <ng-template #template let-option>
                <div
                    *ngIf="option.value"
                    [agprTooltip]="tooltipPath ? tooltipPath + option.value : ''"
                    [tooltipPosition]="tooltipPosition"
                    class="agpr-multiSelectDropdown-panel-item"
                    [ngClass]="{'agpr-multiSelectDropdown-panel-activeItem': option.selected,
                    'agpr-multiSelectDropdown-panel-disabledItem': maxOptionsSelected && !option.selected}"
                >
                    <agpr-checkbox
                        [id]="id + '-autocomplete-option-' + option.label"
                        [label]="option.label"
                        [binary]="true"
                        [disabled]="maxOptionsSelected && !option.selected"
                        [ngModel]="option.selected"
                    ></agpr-checkbox>
                </div>
                <agpr-message
                    *ngIf="!option.value"
                    [severity]="messageSeverityEnum.noContent"
                >
                    {{ 'Common.forms.noSuggestions' | localize }}
                </agpr-message>
            </ng-template>
        </agpr-autocomplete>
        <!-- Trigger Icon -->
        <span
            class="agpr-multiSelectDropdown-triggerIcon "
            [ngClass]="icon || 'fa-solid fa-angle-down agpr-expandToggle'"
            aria-hidden="true"
            (click)="onMouseclick($event)"
        ></span>
        <!-- Dropdown Panel -->
        <div #panel
            [ngClass]="['agpr-multiSelectDropdown-panel', panelStyleClass]"
            [@panelState]="panelVisible ? 'visible' : 'hidden'"
            [style.display]="panelVisible ? 'block' : 'none'"
            class="agpr-clickOutsideExcluded"
            role="listbox"
        >
            <agpr-scroll-panel class="agpr-multiSelectDropdown-scrollPanel">
                @if (optionsListGroups) {
                    <div class="agpr-multiSelectDropdown-optionsListGroup">
                        @for (group of optionsListGroups; track group.label) {
                            <agpr-button
                                class="agpr-multiSelectDropdown-optionsListGroupToggle"
                                [style]="buttonTypes.textToggle"
                                (click)="toggleOptionsListGroup(group)"
                            >
                                <span>{{ group.label }}</span>
                                <span [ngClass]="group.expanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"></span>
                            </agpr-button>
                            @if (group.expanded) {
                                <ng-container *ngTemplateOutlet="itemsTemplate; context: { id: id + group.label, optionsToDisplay: group.options, tooltipPath: tooltipPath, maxOptionsSelected: maxOptionsSelected }"></ng-container>
                            }
                        }
                    </div>
                } @else {
                    <ng-container *ngTemplateOutlet="itemsTemplate; context: { id: id, optionsToDisplay: optionsToDisplay, tooltipPath: tooltipPath, maxOptionsSelected: maxOptionsSelected }"></ng-container>
                }
                <ng-template
                    #itemsTemplate
                    let-id="id"
                    let-optionsToDisplay="optionsToDisplay"
                    let-tooltipPath="tooltipPath"
                    let-maxOptionsSelected="maxOptionsSelected"
                >
                    <div #itemswrapper>
                        <ul class="agpr-multiSelectDropdown-panel-items">
                            <li
                                *ngFor="let option of optionsToDisplay; index as i"
                                [tabindex]="0"
                                [id]="id + '-option_' + i"
                                class="agpr-multiSelectDropdown-panel-item"
                                [ngClass]="{'agpr-multiSelectDropdown-panel-activeItem': option.selected,
                                'agpr-multiSelectDropdown-panel-disabledItem': maxOptionsSelected && !option.selected}"
                                [agprTooltip]="tooltipPath ? tooltipPath + option.value : ''"
                                [tooltipPosition]="tooltipPosition"
                                (click)="onItemClick(option)"
                                role="option"
                                [attr.aria-selected]="option.selected"
                                [attr.aria-disabled]="maxOptionsSelected && !option.selected"
                            >
                                <agpr-checkbox
                                    [id]="id + '-option_' + i + '-checkbox'"
                                    [label]="option.label"
                                    [binary]="true"
                                    [ngModel]="option.selected"
                                    [disabled]="maxOptionsSelected && !option.selected"
                                    [name]="option.label | localize"
                                ></agpr-checkbox>
                            </li>
                        </ul>
                    </div>
                </ng-template>
            </agpr-scroll-panel>
        </div>
    </div>
    <!-- Chips -->
    @if (displayChips) {
        <div class="agpr-multiSelectDropdown-chips" *ngIf="selectedOptions?.length > 0">
            <ul #chips [id]="id + '_chips'">
                <li
                    *ngFor="let option of selectedOptions; index as i"
                    [id]="id + '-chip_' + i"
                    class="agpr-chip"
                    [attr.aria-label]="option.label | localize"
                >
                    <span [id]="id + '-chip_' + i + '-label'" class="agpr-chip-label">{{option.label | localize}}</span>
                    <button
                        *ngIf="!disabled"
                        class="agpr-chip-icon agpr-i-close"
                        [id]="id + '-chip_' + i + '-delete'"
                        (click)="removeItem(option)"
                        agprTooltip="Common.forms.chips.delete"
                        tooltipPosition="top"
                        [useTooltipAsAriaLabel]="false"
                        [attr.aria-label]="(option.label | localize) + ' ' + ('Common.forms.chips.delete' | localize)"
                    >
                    </button>
                </li>
            </ul>
            <agpr-button
                class="agpr-multiSelectDropdown-removeAll"
                [style]="buttonTypes.icon"
                icon="fa-kit-duotone fa-agpr-remove-all"
                [tooltip]="clearSelectionLabel"
                tooltipPosition="left"
                (click)="removeAll()"
            >
            </agpr-button>
        </div>
    }
</div>

